export const CTA_BLUE = "#3B82F6";
export const CTA_INDIGO = "#6366F1";
export const CTA_GRADIENT = `linear-gradient(135deg, ${CTA_BLUE}, ${CTA_INDIGO})`;
export const CTA_SHADOW = "0 4px 14px rgba(59, 130, 246, 0.3)";
